import logo from '../../assets/images/cadLogo.png';
import { LoginDiv, Warper, Logo, Title } from './Login.style';
import LoginForm from '../../components/LoginForm/LoginForm';

const Login = () => {
  return (
    <Warper>
      <Logo src={logo} alt="logo" />
      <LoginDiv>
        <Title>Login Here!</Title>
        <LoginForm />
      </LoginDiv>
    </Warper>
  );
};

export default Login;
